import Vue from "vue";
import router from "../router";
import { functions, api } from "@/firebase.js";

export default {
  state: {
    id: null,
    nombre: "",
    permisos: {
      pruebas: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      preguntas: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      respuestas: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      resultadosFinales: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      categorias: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      dominios: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      dimensiones: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      tests: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      testsEmpleados: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      clientes: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      clientesEmpleados: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      clientesDepartamentos: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      clientesUsuarios: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      perfiles: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      },
      usuarios: {
        consultar: false,
        agregar: false,
        editar: false,
        eliminar: false
      }
    },
    estatus: 1
  },
  mutations: {
    setPerfil(state, perfil) {
      state.id = perfil.id;
      state.nombre = perfil.nombre;
      let permisos = perfil.permisos;
      if (permisos.clientesDepartamentos == undefined) {
        permisos.clientesDepartamentos = {
          consultar: false,
          agregar: false,
          editar: false,
          eliminar: false
        };
      }
      state.permisos = permisos;
      state.estatus = perfil.estatus;
    }
  },
  actions: {
    setPerfil(context, perfil) {
      context.commit("setPerfil", perfil);
    },
    getPerfil(context, id) {
      console.log("id", id);

      api("clienteGetUsuarioById")({
        cliente: { id: localStorage.id_cliente_imperia },
        id: id
      }).then(response => {
        if (response.data != null) {
          console.log("lo encontre");
          if (context.rootState.usuario.id == null) {
            console.log("no hay usuario");
            context.commit("setUsuario", response.data);
            if (context.rootState.cliente.id == null) {
              context.commit("setCliente", response.data.cliente);
            }
          }
          context.commit("setPerfil", response.data.perfil);
          router.push({ name: "Dashboard" });
        }
        context.rootState.menu.ready = true;
      });
    }
  },
  getters: {
    getPerfil(state) {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/perfil.js